import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useModal } from "@/modals"
import {
  INFO_MODAL_TYPES,
  useGetInfoModalHasReadQuery,
  useMarkInfoModalAsReadMutation
} from "@/store/apis/infoModalAPI"
import { Button } from "@/ui/Button"
import { Modal } from "@/ui/Modal"
import { PrivacyPolicyContent } from "@/ui/PrivacyPolicyContent"
import styles from "./PrivacyPolicyModal.module.scss"

const modalType = "privacyPolicy"
const LEGAL_LANG = "en"

export const PrivacyPolicyModal: FC = () => {
  const { modal } = useModal(modalType)
  const { t } = useTranslation()

  const { data, isLoading: isHasReadLoading } = useGetInfoModalHasReadQuery({
    type: INFO_MODAL_TYPES.PRIVACY,
    lang: LEGAL_LANG
  })
  const [markAsRead, { isLoading: isMarkLoading }] =
    useMarkInfoModalAsReadMutation()

  const isGateMode = data?.hasRead !== true

  const handleAgree = async () => {
    await markAsRead({
      type: INFO_MODAL_TYPES.PRIVACY,
      lang: LEGAL_LANG
    }).unwrap()
    modal.close()
  }

  const handleClose = () => modal.close()

  return (
    <Modal.Fullscreen
      type={modalType}
      isCanClose={!isGateMode}
      className={clsx(styles.PrivacyPolicyModal)}
    >
      <div className={clsx(styles.PrivacyPolicyModal_content)}>
        <PrivacyPolicyContent />
      </div>
      <div className={clsx(styles.PrivacyPolicyModal_footer)}>
        <Button
          styles="yellow"
          disabled={isHasReadLoading || isMarkLoading}
          onClick={isGateMode ? handleAgree : handleClose}
        >
          {isGateMode ? t("legal.agree") : t("button.close")}
        </Button>
      </div>
    </Modal.Fullscreen>
  )
}
